import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'

// 100% height is to expand to full height of SplitterPane
export const LeftNavigationPanel = styled.nav<{ isMinimised: boolean }>`
  position: relative;
  height: 100%;
  flex: ${props => (props.isMinimised ? '0 0 44px' : '0 0 200px')};
  overflow: hidden;
  padding-top: 12px;
  background-color: white;
  display: flex;
  flex-direction: column;
  ${mixins.panelTransition};
  &:hover {
    overflow-y: auto;
  }
`
